import React from 'react';
import BLComponent from '../../core/_BLComponent.jsx';
import { ItemTypeNameUtil, MsgUtil } from '../controller/MyCollectionUtils.js';

import CategoryFilterHeader from './_CategoryFilterHeader';

export default class ListHeader extends BLComponent {
	constructor(props, context) {
		super(props, context);	// This should come first. 
	}

	componentDidMount() {
	}

	render() {
		const {item} = this.props.data;

		return (
			<React.Fragment>
				{this.renderSortingControllerMobile()}
				<div className="personal-inventory__list-header l-flex l-split">
					{this.renderItemCntMsg()}
					{this.renderSortingController()}
				</div>
				{(this.isCategorySelected())&& this.renderCategoryHeader()}
			</React.Fragment>
		)
	}

	renderCategoryHeader() {
		const selectedCategory = this.getSelectedCategory();
		return (<CategoryFilterHeader key={selectedCategory} 
			data={{selectedCategory: selectedCategory}} 
			func={{
				toggleCategory: (idCategory, selected)=> this.props.func.toggleCategory(idCategory, selected)
				, clearCategoryFilter: ()=> this.props.func.clearCategoryFilter()
			}}/>);
	}

	renderSortingControllerMobile() {
		const {item} = this.props.data;
		const listingOptions = item.listingOptions;
		return (
			<div className="personal-inventory__list-header l-flex l-split">
				<div className="personal-inventory__list-body  personal-inventory__hide-site-width l-full-width l-margin-bottom">
					<div className="l-flex l-split">
						<div className="l-flex">
							<select id="MPI-viewPerPage-dropdown" className="select personal-inventory__page-cnt-select l-cursor-pointer l-full-width select--tight" value={listingOptions.nListSize} onChange={(e) => this.props.func.updateListSize(e)}>
								{this.renderItemPerPageOptions()}
							</select>
						</div>
						<div className="l-flex l-margin-left personal-inventory__sort-box">
							<div id="MPI-desc-btn" className="personal-inventory__sort-icon text--center l-margin-x--sm l-margin-y--auto l-cursor-pointer" onClick={() => this.props.func.updateSortOrder()}>
								<i className={"fas " + ((listingOptions.nListOrder == 0) ? "fa-sort-amount-down-alt" : "fa-sort-amount-up-alt")}></i>
							</div>
							<select id="MPI-sortBy-dropdown" className="select personal-inventory__sort-select l-cursor-pointer l-full-width select--tight" value={listingOptions.nListSortType} onChange={(e) => this.props.func.updateSortType(e.target.value)}>
								{this.renderSortByOptions()}
							</select>
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderSortingController() {
		const {item} = this.props.data;
		const listingOptions = item.listingOptions;
		return (
			<div className="l-flex">
				<div className="navViewIconSection l-flex">
					<div id="MPI-thumbnailView-btn" onClick={() => this.props.func.updateListType("G")} className={"personal-inventory__nav-view-icon l-flex l-center-v l-center " + (listingOptions.strListViewType == "G" ? "personal-inventory__nav-view-icon--selected" : "personal-inventory__nav-view-icon--unselected")}>
						<i className="fa-solid fa-grid-2"></i>
					</div>
					<div id="MPI-listView-btn" onClick={() => this.props.func.updateListType("L")} className={"personal-inventory__nav-view-icon l-flex l-center-v l-center " + (listingOptions.strListViewType == "L" ? "personal-inventory__nav-view-icon--selected" : "personal-inventory__nav-view-icon--unselected")}>
						<i className="fa-solid fa-bars"></i>
					</div>
				</div>
				<div className="personal-inventory__show-sitewidth">
					<div className="l-flex">
						<div className="l-margin-left">
							<select id="MPI-viewPerPage-dropdown" className="select personal-inventory__page-cnt-select l-cursor-pointer l-full-width select--tight" value={listingOptions.nListSize} onChange={(e) => this.props.func.updateListSize(e)}>
								{this.renderItemPerPageOptions()}
							</select>
						</div>
						<div className="l-flex personal-inventory__sort-box l-margin-left">
							<div id="MPI-desc-btn" className="personal-inventory__sort-icon text--center l-margin-x--sm l-margin-y--auto l-cursor-pointer" onClick={() => this.props.func.updateSortOrder()}>
								<i className={"fas " + ((listingOptions.nListOrder == 0) ? "fa-sort-amount-down-alt" : "fa-sort-amount-up-alt")}></i>
							</div>
							<select id="MPI-sortBy-dropdown" className="select personal-inventory__sort-select l-cursor-pointer l-full-width select--tight" value={listingOptions.nListSortType} onChange={(e) => this.props.func.updateSortType(e.target.value)}>
								{this.renderSortByOptions()}
							</select>
						</div>
					</div>
				</div>
			</div>

		)

	}

	renderItemCntMsg() {
		const {strSearchKeyword, listItemCnt, dispItemType} = this.props.data;
		//const itemCnt = item.cnt;
		const itemTypeName = ItemTypeNameUtil.getFullName(dispItemType);
		
		const itemCntMsg = MsgUtil.getMsgListItemCount(itemTypeName, strSearchKeyword, listItemCnt);
		return (
			<div className="l-flex l-end text--bold">
				{this.renderCategoryTreeBtn(listItemCnt)}
				<div className="l-flex l-center l-center-v l-full-height">{listItemCnt} {itemCntMsg}</div>
			</div>
		)
	}

	renderCategoryTreeBtn(itemCnt) {
		const {showCategoryTree, dispItemType} = this.props.data;
		const classShowCategoryTree = (showCategoryTree)?"selected":"unselected";

		if ( (dispItemType != "A") && (itemCnt > 0) ){
			return(
				<React.Fragment>
					<div className="personal-inventory__show-only-desktop">
						<div className={"l-margin-right l-flex l-center l-center-v personal-inventory__icon-folder-tree personal-inventory__nav-view-icon  personal-inventory__nav-view-icon--" + classShowCategoryTree}>
							<button className="btn btn--blank" onClick={()=>this.props.func.toggleCategoryTreeView()}><i className="fa-regular fa-folder-tree"></i></button>
						</div>
					</div>

					<div className="personal-inventory__show-only-mobile-device">
						<div className={"l-margin-right l-flex l-center l-center-v personal-inventory__icon-folder-tree personal-inventory__nav-view-icon  personal-inventory__nav-view-icon--unselected"}>
							<button className="btn btn--blank" onClick={()=>this.props.func.toggleCategoryTreeModal()}><i className="fa-regular fa-folder-tree"></i></button>
						</div>
					</div>
				</React.Fragment>
			)
		}
		else {
			return null;
		}
	}

	renderItemPerPageOptions() {
		return (
			<React.Fragment>
				<option value={24}>24 per page</option>
				<option value={48}>48 per page</option>
				<option value={96}>96 per page</option>
				<option value={192}>192 per page</option>
			</React.Fragment>
		)
	}

	renderSortByOptions() {
		const {item} = this.props.data;
		return (
			<React.Fragment>
				<option value={1}>Item Name</option>
				<option value={2}>Item No</option>
				<option value={3}>Condition</option>
				{(item.itemType.toLowerCase() == "part")&&
					<option value={4}>Color Name</option>
				}
				<option value={5}>Quantity</option>
				<option value={6}>Notes</option>
			</React.Fragment>
		)
	}

	getSelectedCategory() {
		const {listCategory} = this.props.data;
		let selectedCategory = [];
		
		for (const category of listCategory) {
			if (category.selected) selectedCategory[selectedCategory.length] = {idCategory: category.idCategory,catName:category.catName, itemCnt:category.itemCnt};
		}
		return selectedCategory;
	}

	isCategorySelected() {
		const {listCategory} = this.props.data;
		for (const category of listCategory) {
			if (category.selected) return true;
		}
		return false;
	}
};

